export default __webpack_public_path__ + "static/media/back.31bbac98.svg";